export default "Pompe à chaleur air/eau 2026 — Aides MPR + CEE + Coup de pouce | Solution Éco France";
